import parse from "html-react-parser";
export const HtmlParser = (htmlString="") => (
  parse(
    htmlString,
    {
      transform: ( reactNode, domNode, index ) => {
        if(domNode.type === "text")
          return <span key={index}>{reactNode}</span>
        return reactNode;
      }
    }
  )
)